// extracted by mini-css-extract-plugin
module.exports = {"adapterSlider":"b8_lg","adapterSlider_isNoMargin":"b8_lh","adapterSlider_isNegative":"b8_lj"};